module.exports = __webpack_public_path__ + "img/brouilles-off.bd8dae8b.svg";